import { render, staticRenderFns } from "./ExcluirModal.vue?vue&type=template&id=2558668e&scoped=true"
import script from "./ExcluirModal.vue?vue&type=script&lang=js"
export * from "./ExcluirModal.vue?vue&type=script&lang=js"
import style0 from "./ExcluirModal.vue?vue&type=style&index=0&id=2558668e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2558668e",
  null
  
)

export default component.exports